import Component from 'vue-class-component';
import { Prop, Vue } from 'vue-property-decorator';
import MembersBanner from '@/components/elements/MembersBanner.vue';
import { languageItem } from '@/language/helpers';
@Component({
    name: 'EventDetailMessages',
    components: { MembersBanner },
})
export default class default_1 extends Vue {
    @Prop({ required: true })
    showAddOnBanner;
    @Prop({ default: '' })
    membersBannerClass;
    @Prop({ default: '' })
    wrapperClass;
    get l() {
        return languageItem('reserve');
    }
}
